import { z } from 'zod';
import type { TFunction } from 'i18next';

const orgUnitNameField = (t: TFunction) =>
  z
    .string()
    .min(2, t('organizationUnits:errors.nameMin'))
    .max(50, t('organizationUnits:errors.nameMax'));

export const createOrganizationUnitSchema = (t: TFunction) =>
  z.object({
    name: orgUnitNameField(t),
    description: z.string().max(200, t('organizationUnits:errors.descriptionMax')).optional(),
    icon: z.string().optional(),
    color: z.string().min(1, t('organizationUnits:errors.colorRequired')),
    parentId: z.string().nullable().optional(),
  });

export type CreateOrganizationUnitInput = z.infer<ReturnType<typeof createOrganizationUnitSchema>>;

export const createUpdateOrganizationUnitSchema = (t: TFunction) =>
  z.object({
    name: orgUnitNameField(t).optional(),
    description: z.string().max(200, t('organizationUnits:errors.descriptionMax')).optional(),
    icon: z.string().optional(),
    color: z.string().min(1, t('organizationUnits:errors.colorRequired')).optional(),
    parentId: z.string().nullable().optional(),
  });

export type UpdateOrganizationUnitInput = z.infer<
  ReturnType<typeof createUpdateOrganizationUnitSchema>
>;
